export default __webpack_public_path__ + "static/media/bcbssc-logo-white.9f97bda8.svg";